<div class="upload-wrapper" [class.bordered]="config.mode !== 'button' || files.length > 0">
  <div [hidden]="config.showPreview !== true || (config.mode === 'button' && files.length === 0)" id="content-preview"
    class="ion-text-center">
    <img alt="placeholder" [style.height.px]="config.previewHeight" class="placeholder-img"
      *ngIf="placeHolderImg || placeHolderImg !== ''" [src]="placeHolderImg" />
    <app-content-preview [hidden]="placeHolderImg && placeHolderImg !== ''" #viewer [files]="files"
      [viewHeight]="config.previewHeight" [allowRemove]="config.allowRemove" (fileRemoved)="removeFile($event)"
      [showThumbnails]="config.showThumbnails" [thumbSize]="config.thumbSize" [uploadTitle]="uploadTitle" [uploadDetails]="uploadDetails" (browse)="onBrowse()">
    </app-content-preview>
  </div>

  <div class="c lh25" *ngIf="disabled === true && files.length === 0">
    No File Uploaded
  </div>

  <ng-container *ngIf="disabled === false">
    <input type="file" [id]="id" class="fileInput" hidden="true" [accept]="config.acceptedTypes" [attr.multiple]="config.maxFiles > 1 ? '' : null"
      (change)="selectFile($event)" class="upload" />
    <input type="file" [id]="id + 'v'" class="fileInput" hidden="true" accept="video/*" capture="environment"
      (change)="selectFile($event)" class="upload" />
    <ng-container *ngIf="config.showPreview !== true">
      <ion-item lines="none" *ngIf="lastFile.path != null">
        <ion-label class="ion-text-wrap ion-text-center">
          <p class="ion-text-center">{{lastFile.filename ?? lastFile.path}}</p>
        </ion-label>
      </ion-item>
      <ion-buttons *ngIf="config.allowRemove === true && files.length > 0" class="rmv-img-btn">
        <ion-button color="danger" fill="clear" (click)="removeFile(lastFile)">
          <ion-icon slot="end" name="close-circle-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ng-container>


    <!-- upload buttons -->
    <div *ngIf="filesRemaining> 0 || config.allowChange" class="ion-text-center">
      <ng-container *ngIf="config.mode !== 'button'">
        <hr class="w100pct">
        <ion-button (click)="triggerBrowse()" size="small" color="primary">
          <ion-icon name="cloud-upload" slot="end"></ion-icon>
          <span *ngIf="showUploadButtonText">Browse </span>
        </ion-button>

        <ng-container *ngIf="isCordova">

          <ion-button (click)="takePicture()" size="small" expand="block" fill="solid" shape="round">
            <p *ngIf="showUploadButtonText" class="fs-sm">Photo</p>
            <ion-icon name="camera"></ion-icon>
          </ion-button>

          <ion-button (click)="showLibrary()" size="small" expand="block" fill="solid" shape="round">
            <p *ngIf="showUploadButtonText" class="fs-sm">Library</p>
            <ion-icon name="camera"></ion-icon>
          </ion-button>

        </ng-container>
      </ng-container>

      <ion-button *ngIf="config.mode === 'button'" (click)="triggerBrowse()">
        <ion-icon name="cloud-upload" slot="start"></ion-icon> Upload
      </ion-button>

    </div>
  </ng-container>

</div>
